import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useReport = () => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["report"],
    queryFn: () => {
      return fetch(`${API}/api/report`, {
        method: "GET",
      }) as Promise<{
        orders: {
          urban_partner: string;
          total: number;
          delivery_fee: number;
          seed_total: number;
          farmer_total: number;
        }[];
        farmer_orders: {
          farmer: string;
          total: number;
        }[];
      }>;
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useReport;
